module.exports = __webpack_public_path__ + "static/img/img-product-deposito-example.8277291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-product-deposito-example.png
// module id = gfe7
// module chunks = 36